import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
  [action.GET_MEETING_LIST](state, data) {
    state.meetingsList = data;
  },
  [action.GET_DEFAULT_MEETING_LIST](state, data) {
    state.defaultMeetingsList = data;
  },
  [action.GET_CUSTOM_MEETING_LIST](state, data) {
    state.customMeetingsList = data;
  },
  [action.GET_MEETING_BY_ID](state, data) {
    state.meetingDetails = data;
    if (data.transcript_document && data.transcript_status) {
      state.transcriptionDetail = {
        document: data.transcript_document,
        status: data.transcript_status,
        transcript_error_message:
          data.transcript_error_message ?? "msgTranscriptionQueueStatus",
      };
    } else {
      state.transcriptionDetail = null;
    }
  },
  [action.GET_CONVOCATION_BY_ID](state, data) {
    state.convocationContent = data;
  },
  [action.SET_MEETING_FILTER_TYPE](state, data) {
    state.default_meetting_filter = data;
  },
  setMeetingType(state, label) {
    state.meetingTypeSelection = label;
  },
  [action.GET_MEETING_LIST_BY_TYPE](state, data) {
    state.meetingListByType = data;
  },
  [action.GET_MEETING_LIST_BY_FILTER](state, data) {
    state.meetingFilterData = data;
  },
  [action.GET_UPCOMMING_MEETING_LIST](state, data) {
    state.upcommingMeetingList = data;
  },
  setMeetingTimerCount(state, meetingTimerClick) {
    state.meetingTimerClick = meetingTimerClick;
  },
  setMeetingTimerPopup(state, meetingTimerPopup) {
    state.meetingTimerPopup = meetingTimerPopup;
  },
  [action.GET_MEETING_VOTER_SUMMARY](state, data) {
    state.meetingVoterSummary = data;
  },
  [action.GET_MEETING_COMMENT_LIST](state, data) {
    state.meetingCommentList = data;
  },
  [action.GET_MEETING_MOM_LOG](state, data) {
    state.meetingMomLogs = data;
  },
  setTranscriptionStatus(state, data) {
    state.transcriptionDetail = data;
  },
  setWanSignEmailStatus(state, data) {
    state.momSignatureData = data;
  },
  [action.SET_DELETED_USER](state, payload) {
    state.deletedUserList = payload;
  },
  [action.ADD_DELETED_USER](state, payload) {
    state.deletedUserList.push(payload);
  },
  [action.DELETE_DELETED_USER](state, id) {
    state.deletedUserList = state.deletedUserList.filter(item => item.id !== id);
  },
  [action.RESET_STATE](state) {
    Object.assign(state, initialState);
  },
  setVotingData(state, data) {
    state.meetingVotingData = data;
  },
};

export default mutations;
